<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
  export default {
    mounted() {
      (function(doc, win) {
        var docEl = doc.documentElement,
          resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize',
          recalc = function() {
            var clientWidth = docEl.clientWidth;
            if (!clientWidth) return;
            docEl.style.fontSize = (clientWidth / 7.5) + 'px';
            if (clientWidth > 1024) {
              docEl.style.fontSize = '100px';
            }
          };
        if (!doc.addEventListener) return;
        win.addEventListener(resizeEvt, recalc, false);
        //doc.addEventListener('DOMContentLoaded', recalc, false);
        recalc();
      })(document, window);
    }
  }
</script>

<style>
  body,
  html {
    height: 100%;
  }

  #app {
    width: 100%;
    height: 100%;
    overflow-x: hidden
  }

  .van-cell,
  .van-cell__value {
    overflow: visible
  }

  .van-icon-warn {
    color: #ff3860;
    top: 2px;
    margin-right: 3px;
  }
  .van-dialog__confirm, .van-dialog__confirm:active {
    color: #f54343;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue